import React, { useContext } from "react";
import TextInput from "../fields/TextInput";
import Checkbox from "../fields/Checkbox";
import classes from "../../styles/styles.module.scss";
import { ConfigContext } from "../../context";

const UserDetailsStage = () => {
  const { user: email, phone } = useContext(ConfigContext);
  const anonUser = !email;
  return (
    <div className={classes.StageWrapper}>
      {anonUser && (
        <div className={classes.FormControl}>
          <TextInput name="userName" label="Your name" value="" />
        </div>
      )}
      {anonUser && (
        <div className={classes.FormControl}>
          <TextInput
            name="userEmail"
            label="Your email"
            value={email}
            type="email"
          />
        </div>
      )}
      <div className={classes.FormControl}>
        <TextInput
          name="userPhone"
          label="Your phone number"
          value={phone}
          type="tel"
        />
      </div>
      {anonUser && (
        <div className={classes.FormControl}>
          <Checkbox name="newsletter">
            I’d love to hear about new venues, top tips, offers &amp; rewards
            (see{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.venuescanner.com/terms-and-conditions"
            >
              privacy policy
            </a>
            )
          </Checkbox>
        </div>
      )}
      {anonUser && (
        <div className={classes.FormControl}>
          <Checkbox name="isTOSAccepted">
            I agree to the{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.venuescanner.com/terms-and-conditions"
            >
              Terms and Conditions
            </a>
          </Checkbox>
        </div>
      )}
    </div>
  );
};

export default UserDetailsStage;
